<template>
  <div>

    <Row class="content-info">
      <Row>
        <Form ref="formValidate"
              :rules="cashierFlowEntityValidate"
              :model='cashierFlowEntityInfo'
              class="edit-list-form">
          <Table :columns="tableColumns" :data="cashierFlowEntityList" border :loading="isListLoading">
            <template slot-scope="{ row, index }" slot="entityName">
              <FormItem prop="entityName" v-if="editIndex === index">
                <Input v-model="entityName" :placeholder="$t('module.proj.project.cashierFlowEntity.info.entityNamePH')" clearable />
              </FormItem>
              <span v-else>
                  {{ row.entityName }}
                </span>
            </template>

            <template slot-scope="{ row, index }" slot="entityDesc">
              <FormItem prop="entityDesc" v-if="editIndex === index">
                <Input v-model="entityDesc" :placeholder="$t('module.proj.project.cashierFlowEntity.info.entityDescPH')" clearable />
              </FormItem>
              <span v-else>
                  {{ row.entityDesc }}
                </span>
            </template>

            <template slot-scope="{ row, index }" slot="entityContact">
              <FormItem prop="entityContact" v-if="editIndex === index">
                <Input v-model="entityContact" :placeholder="$t('module.proj.project.cashierFlowEntity.info.entityContactPH')" clearable />
              </FormItem>
              <span v-else>
                  {{ row.entityContact }}
                </span>
            </template>

            <template slot-scope="{ row, index }" slot="indUsed">
                <span :style="isUsedItem(row) ? {color: '#52C41A'} : {}">
                  {{ formatI18nValue('common.commonVar.indUsedList.', row.indUsed) }}
                </span>
            </template>

            <template slot-scope="{ row, index }" slot="crtOn">
              <span>{{ (row.crtOn) }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="action" v-if="authedFnKeyMap.FMFFER">
              <div v-if="row.isBottomRow">
                <div v-if="editIndex === index">
                  <Button @click="handleInsert(index)" type="primary">{{$t("common.commonVar.actionSave")}}</Button>
                  <Button @click="editIndex = -1" :style="{marginLeft:'10px'}">{{$t("common.commonVar.actionCancel")}}</Button>
                </div>
                <div v-else>
                  <Button @click="handleAdd(row, index)" type="primary">{{$t("common.commonVar.actionAdd")}}</Button>
                </div>
              </div>
              <div v-else>
                <div v-if="editIndex === index">
                  <Button @click="handleUpdate(index)" type="primary">{{$t("common.commonVar.actionSave")}}</Button>
                  <Button @click="editIndex = -1" :style="{marginLeft:'10px'}">{{$t("common.commonVar.actionCancel")}}</Button>
                </div>
                <div v-else>
                  <Button @click="handleEdit(row, index)">{{$t("common.commonVar.actionEdit")}}</Button>
                  <Button @click="handleRemove(index)" :style="{marginLeft:'10px'}" type="error" :disabled="isUsedItem(row)">{{$t("common.commonVar.actionDelete")}}</Button>
                </div>
              </div>
            </template>
          </Table>
        </Form>
      </Row>
    </Row>

  </div>
</template>

<script>
import * as Utils from '@/utils'

export default {
  components: {
    // Tree
  },
  data() {
    return {
      isListLoading: false,
      isShowPairSpin: false,
      // isUpdateLoading: false,
      // isDeleteLoading: false,
      parentPath: '',
      parentTitle: '',
      tableColumns: [
        {
          title: this.$t('module.proj.project.cashierFlowEntity.info.entityName'),
          slot: 'entityName',
          renderHeader: Utils.renderHeader
        },
        {
          title: this.$t('module.proj.project.cashierFlowEntity.info.entityDesc'),
          slot: 'entityDesc',
          renderHeader: Utils.renderHeader
        },
        {
          title: this.$t('module.proj.project.cashierFlowEntity.info.entityContact'),
          slot: 'entityContact',
          renderHeader: Utils.renderHeader
        },
        {
          title: this.$t('common.commonVar.indUsed'),
          slot: 'indUsed',
          width: 100,
          renderHeader: Utils.renderHeader
        },
        {
          title: this.$t('common.commonVar.addOn'),
          slot: 'crtOn',
          width: 170,
          renderHeader: Utils.renderHeader,
          render: (h, params) => {
            // debugger
            return h('div', {
              prop: {
                type: 'text'
              }
            }, Utils.formatDate(new Date(params.row.crtOn)))
          }
        },
        {
          title: this.$t('common.commonVar.action'),
          slot: 'action',
          align: 'center',
          width: 200,
          renderHeader: Utils.renderHeader
        }
      ],
      cashierFlowEntityValidate: {
        entityName: [
          { required: true, message: this.$t('module.proj.project.cashierFlowEntity.validateInfo.entityNameRequired'), trigger: 'change' }
        ]
      },
      END_DATA: null
    }
  },
  computed: {
    resourceList() {
      return this.$store.state.permission.resourceList
    },
    authedFnKeyMap() {
      return this.$store.state.systemAuthManage.authedFnKeyMap
    },
    cashierFlowEntityList() {
      return this.$store.state.confCashierFlowEntityManage.cashierFlowEntityList
    },
    cashierFlowEntityInfo() {
      return this.$store.state.confCashierFlowEntityManage.cashierFlowEntityInfo
    },
    entityId: {
      get() {
        return this.cashierFlowEntityInfo.entityId
      },
      set(value) {
        this.$store.commit('confCashierFlowEntityManage/updateEntityId', value)
      }
    },
    entityName: {
      get() {
        return this.cashierFlowEntityInfo.entityName
      },
      set(value) {
        this.$store.commit('confCashierFlowEntityManage/updateEntityName', value)
      }
    },
    entityDesc: {
      get() {
        return this.cashierFlowEntityInfo.entityDesc
      },
      set(value) {
        this.$store.commit('confCashierFlowEntityManage/updateEntityDesc', value)
      }
    },
    entityContact: {
      get() {
        return this.cashierFlowEntityInfo.entityContact
      },
      set(value) {
        this.$store.commit('confCashierFlowEntityManage/updateEntityContact', value)
      }
    },
    editIndex: {
      get() {
        return this.$store.state.confCashierFlowEntityManage.editIndex
      },
      set(value) {
        this.$store.commit('confCashierFlowEntityManage/updateEditIndex', value)
      }
    },
    editAction: {
      get() {
        return this.$store.state.confCashierFlowEntityManage.editAction
      },
      set(value) {
        this.$store.commit('confCashierFlowEntityManage/updateEditAction', value)
      }
    },
    indUsedList() {
      return this.$store.state.indUsedList
    },
    END_COMPUTED() {
      return null
    }
  },
  methods: {
    formatI18nValue(prefix, value) {
      return value ? this.$t(prefix + value) : null
    },
    initFormValue() {
      // this.commit('confCashierFlowEntityManage/updateEditIndex', -1)
    },
    cleanForm() {
      // this.$store.commit('projPtcpManage/updatePtcpListEmpty')
    },
    // goBack() {
    //   this.$router.push({name: 'RspProjectHomePage'})
    // },
    getKeyParam() {
      return { projId: this.$route.query.projId, compId: this.$route.query.compId }
    },
    async handleAdd(row, index) {
      this.$store.commit('confCashierFlowEntityManage/handleAdd', {row, index})
    },
    async handleInsert(row, index) {
      // debugger
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          this.doInsert(index)
        } else {
          this.$Message.error({
            content: this.$t('common.commonVar.requiredFieldContent')
          })
        }
      })
    },
    async doInsert(index) {
      const result = await this.$store.dispatch('confCashierFlowEntityManage/insertCashierFlowEntity', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
      if (result.success) {
        this.$Message.success({
          content: this.$t('common.commonVar.insertSuccess')
        })
        await this.refreshList()
      }
    },
    async handleEdit(row, index) {
      this.$store.commit('confCashierFlowEntityManage/handleEdit', {row, index})
    },
    async handleUpdate(index) {
      // debugger
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          this.doUpdate(index)
        } else {
          this.$Message.error({
            content: this.$t('common.commonVar.requiredFieldContent')
          })
        }
      })
    },
    async doUpdate(index) {
      const result = await this.$store.dispatch('confCashierFlowEntityManage/updateCashierFlowEntity', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route), entityId: this.cashierFlowEntityList[index].entityId})
      if (result.success) {
        this.$Message.success({
          content: this.$t('common.commonVar.updateSuccess')
        })
        await this.refreshList()
      }
    },
    async handleRemove(index) {
      this.$Modal.confirm({
        title: this.$t('common.commonVar.notice'),
        content: this.$t('common.commonVar.noticeContent'),
        onOk: () => this.doRemove(index)
      })
    },
    async doRemove(index) {
      const result = await this.$store.dispatch('confCashierFlowEntityManage/removeCashierFlowEntity', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route), entityId: this.cashierFlowEntityList[index].entityId})
      if (result.success) {
        this.$Message.success({
          content: this.$t('common.commonVar.delSuccess')
        })
        await this.refreshList()
      }
    },
    async refreshList() {
      // debugger
      this.editIndex = -1
      this.isListLoading = true
      await this.$store.dispatch('confCashierFlowEntityManage/findCashierFlowEntityList', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})
      this.$store.commit('confCashierFlowEntityManage/appendBottomRow')
      this.isListLoading = false
    },
    isActiveItem: Utils.isActiveItem,
    isUsedItem: Utils.isUsedItem,
    findItemDescrByValue: Utils.findItemDescrByValue,
    END_METHODS() {}
  },
  async mounted() {
    // debugger
    this.isShowPairSpin = true
    this.parentPath = Utils.getUrlByMenuKey(this.resourceList, this.$route.query.menuKey)
    this.parentTitle = Utils.getNameByMenuKey(this.resourceList, this.$route.query.menuKey)

    this.$store.commit('confCashierFlowEntityManage/updateCashierFlowEntityListEmpty')
    await this.$store.dispatch('systemAuthManage/findProjAuth', {...this.getKeyParam(), ...Utils.getCodeParam(this.$route)})

    await this.refreshList()
    this.isShowPairSpin = false
  },
  async destroyed() {
    // debugger
    this.cleanForm()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/proj/CashierFlowEntityCard.vue